import { track } from './segment';

export type VerifyEmailErrorLike = { __typename?: string; message?: string };

// Pure builder so the payload shape can be unit-tested independently of XState.
export const buildVerifyEmailErrorPayload = (emailAddress: string | undefined, errors: ReadonlyArray<VerifyEmailErrorLike>) => {
  const triggerCheck = errors.find((e) => e.__typename === 'InvalidEmailError')?.message ?? errors[0]?.__typename ?? 'unknown';
  return {
    validationType: 'email' as const,
    triggerCheck,
    badDomain: emailAddress?.split('@')[1] ?? '',
  };
};

export const trackEmailValidationError = (context: any, event: any) => {
  const payload = buildVerifyEmailErrorPayload(context?.basicInfo?.emailAddress, event?.data ?? []);
  return track('Email Validation Error', payload)(context, event);
};
